import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useState, type ReactElement, type SyntheticEvent } from "react";

export interface MdaiAccordionItemProps {
  summary: string;
  details: string | ReactElement;
}

export interface MdaiAccordionProps {
  align?: string;
  title?: string;
  subtitle?: string;
  items: MdaiAccordionItemProps[];
}

export function MdaiAccordion({
  align,
  title,
  subtitle,
  items,
}: MdaiAccordionProps) {
  const [expanded, setExpanded] = useState<string | false>("panel-0");

  const handleChange =
    (panel: string) => (_event: SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };

  return (
    <Stack sx={{ maxWidth: "650px" }} justifyContent={"center"}>
      {(title ?? subtitle) && (
        <Stack spacing={2} alignItems={align ?? "center"} mb={4}>
          {title && (
            <Typography
              variant="h3"
              sx={{
                textAlign: "center",
                mb: "3",
                mt: "1",
              }}
            >
              {title}
            </Typography>
          )}
          {subtitle && (
            <Typography variant="body1" textAlign={"center"} mb={2} mt={2}>
              {subtitle}
            </Typography>
          )}
        </Stack>
      )}
      <Stack mx={3} gap={3}>
        {items.map(({ summary, details }, idx) => (
          <div key={summary}>
            <Accordion
              expanded={expanded === `panel-${idx.toString()}`}
              onChange={handleChange(`panel-${idx.toString()}`)}
              sx={{
                backgroundColor: "#1e1e1e",
              }}
            >
              <AccordionSummary
                expandIcon={
                  <ExpandMoreIcon sx={{ fill: "rgba(255, 255, 255, 0.56)" }} />
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <Typography
                  component="span"
                  sx={{
                    fontSize: "20px !important",
                  }}
                >
                  {summary}
                </Typography>
              </AccordionSummary>
              <AccordionDetails
                sx={{
                  paddingX: { sm: 1, md: 2 },
                }}
              >
                {details}
              </AccordionDetails>
            </Accordion>
          </div>
        ))}
      </Stack>
    </Stack>
  );
}
